// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__-EuV+"};